<template>
  <div class="header_father">
    <div id="headerNav" ref="fixedHeader" class="headerNav">
      <el-header>
        <div class="header">
          <div>
            <img style="margin-top: 10px;" src="../../assets/img/menu/cut_icon.png" alt class="cut_icon"
              @click="navHiddenFun(1)" v-show="cuticon">
            <img src="../../assets/img/menu/icon_Collapse.png" alt class="cut_icon" @click="navHiddenFun(2)"
              v-show="cuticon2">
            <el-select filterable v-model="Kefuid" class="select_kefuid" @change="changeKefuid" v-if="KefuidShow"
              size="small">
              <el-option v-for="(item, i) in KefuidList" :key="i + 'a533'"
                :label="item.company_memoname ? '【' + item.bmcid + '】 ' + item.company_memoname : '【' + item.bmcid + '】 ' + item.companyname"
                :value="item.bmcid">
              </el-option>
            </el-select>
          </div>
          <div class="home_right">
            <i class="el-icon-data-line" @click="jump(5)"
              style="font-size: 24px;color: #bda571;cursor: pointer;padding: 0 20px;font-size: 24px;height: 49px;line-height: 49px;"></i>
            <i class="el-icon-data-line" v-show="daShow4" @click="jump(4)"
              style="font-size: 24px;color: #bda571;cursor: pointer;padding: 0 20px;font-size: 24px;height: 49px;line-height: 49px;"></i>
            <i class="el-icon-data-analysis" v-show="daShow" @click="jump(1)"
              style="font-size: 24px;color: #bda571;cursor: pointer;padding: 0 20px;font-size: 24px;height: 49px;line-height: 49px;"></i>
            <i class="el-icon-tickets" v-show="daShow2" @click="jump(2)"
              style="font-size: 24px;color: #bda571;cursor: pointer;padding: 0 20px;font-size: 24px;height: 49px;line-height: 49px;"></i>
            <i class="el-icon-document-copy" v-show="daShow3" @click="jump(3)"
              style="font-size: 24px;color: #bda571;cursor: pointer;padding: 0 20px;font-size: 24px;height: 49px;line-height: 49px;"></i>

            <el-popover trigger="click" width="400" popper-class="infoAlert">
              <div>
                <div class="title">消息（{{ taskList.length }}）</div>
                <div class="nodata" style="height: 360px;line-height: 360px;" v-if="taskList.length == 0"><img
                    src="@/assets/img/other/nodata.svg">暂无数据</div>
                <div class="infoContainer" v-else>
                  <div class="info" v-for="(item, index) in taskList" :key="index + 'a8sss'"
                    @click="changeKefuid(item.bmcid)">
                    <div class="replace headLine">【{{ item.bmcid }}】{{ item.bmcname }}</div>
                    <div class="replace">
                      <span v-if="item.reportstatus == 1" style="color: red;">
                        违规处理,
                      </span>
                      <span v-if="item.datastatus == 1" style="color: red;">
                        数据中心
                      </span>
                      模块有未完成的工作
                    </div>
                    <div class="replace" style="font-size: 13px;">{{ item.createtime | fullTime }}</div>
                  </div>
                </div>
              </div>
              <div class="active_icon_container" slot="reference" @click="getHcmTaskList()">
                <img src="../../assets/img/menu/active_icon.png" class="active_icon">
              </div>
            </el-popover>

            <el-popover trigger="click" width="400" popper-class="infoAlert">
              <div>
                <div class="title">消息（{{ GetNotReadlistData.unRead }}）</div>
                <div class="nodata" style="height: 360px;line-height: 360px;"
                  v-if="GetNotReadlistData.list.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
                <div class="infoContainer" v-else>
                  <div class="info" v-for="(item, i) in GetNotReadlistData.list" :key="i + 'qsd5'"
                    @click="checkMessageDetail(item)">
                    <div class="replace headLine" style="font-size: 14px;font-weight: bold;margin-bottom: 5px;">
                      {{ item.topic }}</div>
                    <div
                      style="font-size: 14px;margin-bottom: 5px;color: #00000072;display: -webkit-box;-webkit-line-clamp:2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;">
                      {{ ToText(item.content) }}
                    </div>
                    <div class="replace" style="font-size: 12px;margin-bottom: 5px;color: #00000072;">{{ item.createtime
                      | fullTime}}</div>
                  </div>
                </div>
                <div class="all" @click="allInfoRead">全部消息</div>
              </div>
              <div class="active_icon_container" slot="reference">
                <img src="../../assets/img/menu/infotm_icon.png" alt class="infotm_icon">
              </div>
            </el-popover>
            <div class="name_container">
              <span class="name">{{ firstName }}</span>
              <span class="fullName f14">{{ realname }}</span>
            </div>
            <img src="../../assets/img/menu/remove_icon.png" alt class="infotm_icon infotm_icon2" @click="exit">
          </div>
        </div>
      </el-header>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from "vuex";
import { mapState } from "vuex";
import { setTimeout } from 'timers';
export default {
  name: "headerNav",
  inject: ['reload'],
  computed: {
    ...mapGetters(["GetNotReadlistData", "selectStatusData", "Kefuidsget"]),
  },
  data: function () {
    return {
      Kefuid: '',
      KefuidShow: false,
      news: [],
      select: [],
      userData: {},
      realname: '',
      firstName: "",
      usertype: '',
      KefuidList: [],
      navHidden: false,
      cuticon: true,
      cuticon2: false,
      taskList: [],
      daShow: false,
      daShow2: false,
      daShow3: false,
      daShow4: false,
    }
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem('userData'));//获取用户信息
    this.userData = userData
    this.firstName = this.userData.realname.slice(0, 1)
    this.usertype = localStorage.getItem('usertype')
    this.userData = JSON.parse(localStorage.getItem('userData')).logintype
    this.realname = userData.realname
    console.log(userData, 'userData')
    if (userData.dateplatformStatus == '1') {
      this.daShow = true
    } else {
      this.daShow = false
    }
    if (userData.databoardStatus == '1') {
      this.daShow2 = true
    } else {
      this.daShow2 = false
    }
    if (userData.dataloginStatus == '1') {
      this.daShow3 = true
    } else {
      this.daShow3 = false
    }
    if (userData.majorproducts == '1') {
      this.daShow4 = true
    } else {
      this.daShow4 = false
    }

    if (this.userData == 'KEFU') {
      this.getBmcListByKefuid()
    }
    if (userData.logintype == 'KEFU') {
      this.KefuidShow = true
    }
  },
  created() {
    this.GetNotReadlistGet()
    this.GetselectStatus()
    this.getHcmTaskList()
    const Kefuid = localStorage.getItem('Kefuid');
    if (Kefuid) this.Kefuid = Number(Kefuid)
  },
  methods: {
    jump(e) {
      if (e == 1) {
        window.open('https://brm.olonger.com/#/dataSize');
      } else if (e == 2) {
        this.$router.replace({ path: '/priceControlBoard' });
      } else if (e == 3) {
        this.$router.replace({ path: "/kanbanDataDetil" })
      } else if (e == 4) {
        this.$router.replace({ path: '/priceSize' });
      } else if (e == 5) {
        this.$router.replace({ path: '/diagnosis' });
      }
    },
    // 反馈
    getHcmTaskList() {
      fetch({
        url: "hcm/hcmTask/getHcmTaskList",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res)
        if (result.status == '10000') {
          this.taskList = result.data
        }
      })
    },
    ToText(HTML) {
      if (HTML == null) {

      } else {
        var notice_content = HTML;
        return notice_content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '').replace(/<[^>]+?>/g, '').replace(/\s+/g, ' ').replace(/ /g, ' ').replace(/>/g, ' ').replace(/[ ]|[&nbsp;]/g, ' ');
      }

    },
    ...mapActions(['GetNotReadlistGet', 'GetselectStatus']),
    toMainFK(index) {
      //反馈详情
      let name = this.selectStatusData.list[index].details
      let id = this.selectStatusData.list[index].id
      this.$router.replace({ path: '/feedbackDetilis', query: { name, id } })
      this.reload()//刷新路由
    },
    checkMessageDetail(item) {
      this.$router.push(`/MessageCenter/${item.id}`)
    },
    allselectStatus() {
      this.$router.replace({ path: '/PersonalCenter/systemFeedback' })
    },
    allInfoRead() {
      this.$router.replace({ path: '/MessageCenter/:id' })
    },
    navHiddenFun(e) {
      this.$emit('changeNav')
      if (e == 1) {
        this.cuticon = false
        this.cuticon2 = true
      } else {
        this.cuticon = true
        this.cuticon2 = false
      }
    },
    exit() {
      //退出登录
      localStorage.removeItem('userData');
      localStorage.removeItem('usertype');
      localStorage.removeItem('token');
      localStorage.clear()
      this.$router.replace({ path: '/login' })
      let _this = this
      setTimeout(() => {
        _this.reload()
      }, 1000)
      this.$router.go(0);
    },
    getBmcListByKefuid() {
      fetch({
        url: "hcm/userin/getBmcListByKefuid",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res)
        if (result.status == '10000') {
          let name
          this.KefuidList = result.data
          this.KefuidCheck = result.data[0].companyname
          for (let item of result.data) {
            if (item.checked == 'true') {
              this.Kefuid = Number(item.bmcid)
              localStorage.setItem('bmcKefuid', this.Kefuid);
              localStorage.setItem('bmcKefuName', item.company_memoname);
              name = item.company_memoname
            }
          }
          // bmcid
          this.$notify.info({
            title: '消息',
            message: '当前品牌方' + '【' + this.Kefuid + '】' + name
          });
        }
      })
    },
    changeKefuid(val) {
      console.log(val)
      this.Kefuid = val
      localStorage.setItem('Kefuid', val);
      localStorage.setItem('bmcKefuid', val);
      //  切换
      fetch({
        url: "hcm/changeBmcId",
        method: "post",
        data: {
          'bmcid': val,
          'type': 1,
        }
      })
        .then((res) => {
          let name
          for (let a in this.KefuidList) {
            if (val == this.KefuidList[a].bmcid) {
              name = this.KefuidList[a].company_memoname
            }
          }
          localStorage.setItem('bmcKefuName', name);
          this.$notify.info({
            title: '消息',
            message: '当前品牌方' + '【' + val + '】' + name
          });
          this.$router.replace({ path: "/homeInterim" });
        })
    },
  }
}
</script>

<style lang="scss">
.header_father {
  width: 100%;
  height: 90px;
}

#headerNav {
  .infotm_icon2 {
    margin-left: 10px;
  }

  .name_container {
    margin: 0 20px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  z-index: 999;
  position: fixed;
  width: calc(100% - 184px);
  min-width: 920px;

  .el-header {
    padding: 0 20px 0px 20px;
    height: 50px !important;
    background: #fff;
    border-bottom: 1px solid #d9d9d9;
  }

  .select_kefuid {
    margin-left: 15px;

    .el-input__inner {
      height: 32px;
      height: 32px;
    }

  }

  .header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: space-between;

    .home_right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;

      &>span {
        display: flex;
        align-items: center;
        height: 100%;

        &>div {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      .active_icon_container {
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;

        &:hover {
          cursor: pointer;
          background: #faf8f4;
        }

        .num {
          position: absolute;
          right: 11px;
          top: 3px;
          display: inline-block;
          width: 20px;
          height: 20px;
          font-size: 10px;
          background: #d4282d;
          color: #fff;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
        }
      }

      .name {
        width: 26px;
        height: 26px;
        background: #bda571;
        color: #fff;
        font-size: 14px;
        border-radius: 50%;
        line-height: 26px;
        text-align: center;
        display: inline-block;
        font-weight: bold;
      }

      .fullName {
        display: inline-block;
        margin: 0 5px;
        max-width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 14px;
      }
    }
  }
}

.infoAlert {
  padding: 0;

  .title {
    font-size: 14px;
    /*padding:5px 16px 5px;*/
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #e8e8e8;
    padding-left: 20px;
    color: #333;
  }

  .infoContentContainer {
    max-height: 200px;
    overflow-y: auto;
  }

  .infoContent {
    padding: 12px 13px;
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;

    .imgInform {
      width: 80px;
      text-align: center;

      img {
        width: 32px;
        height: 32px;
      }
    }

    .hint {
      color: #565c5f;
      font-size: 14px;
    }

    .cont {
      font-size: 12px;
      height: 40px;
      color: #818a8f;
    }

    .c818 {
      color: #818a8f;
    }
  }

  .infoContainer {
    height: 360px;
    overflow-y: auto;
    padding: 10px 40px;
  }

  .headLine {
    overflow: hidden; //隐藏文字
    text-overflow: ellipsis; //显示 ...
    white-space: nowrap; //不换行
    width: 100%;
  }

  .info {
    border-bottom: 1px solid #e8e8e8;
    padding: 5px 0;
    color: #666;
    cursor: pointer;

    .replace {
      line-height: 24px;
    }

    ;
    cursor: pointer;
  }

  .all {
    padding: 10px;
    text-align: center;
    color: #1890ff;
    border-top: 1px solid #e8e8e8;
    cursor: pointer;
    display: block;
    width: 100%;
    text-decoration: none;
  }
}
</style>
